import { configureStore } from '@reduxjs/toolkit';
import generalReducer from './slices/generalSlice';
import weatherDataReducer from './slices/weatherDataSlice';
import upcomingEventReducer from './slices/upcomingEventSlice';
import clubPageReducer from './slices/clubSlice';
import notificationReducer from './slices/notificationSlice';

export const store = configureStore({
  reducer: {
    general: generalReducer,
    weatherData: weatherDataReducer,
    upcomingEvent: upcomingEventReducer,
    clubPage: clubPageReducer,
    notification: notificationReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;